import { ProgressBar } from "web-ui";

import type { ObjectiveProgress } from "../api/languageChallenge";
import streakFlame from "../images/flame.gif";
import streakPhoenix from "../images/streak-phoenix.svg";
import styles from "../styles/StreakProgress.module.scss";

export interface Props {
  className?: string;
  objective: ObjectiveProgress;
}

const IncompleteStreakProgress = ({ className, objective }: Props) => {
  const progressDenominator = objective.goal;
  const progressNumerator = Math.min(objective.progress, progressDenominator);
  return (
    <div className={className}>
      <ProgressBar
        className={styles["progress-bar"]}
        denominator={progressDenominator}
        height={20}
        numerator={progressNumerator}
      />
      <div className={styles["streak-container"]}>
        <img alt="streak flame" height={30} src={streakFlame} width={30} />
        <div>
          <span className={styles["xp-numerator"]}>{objective.progress}</span>
          {` / ${objective.goal} day longest streak during challenge`}
        </div>
      </div>
    </div>
  );
};

const CompleteStreakProgress = ({ objective }: Props) => (
  <div className={styles["complete-streak-container"]}>
    <div className={styles["complete-streak-phoenix"]}>
      <img alt="streak phoenix" height="auto" src={streakPhoenix} width={175} />
    </div>

    <div className={styles["complete-streak-description"]}>
      You completed the streak objective with a longest streak of{" "}
      {objective.progress} days during the challenge!
    </div>
  </div>
);
const StreakProgress = ({ className, objective }: Props) =>
  objective.isComplete ? (
    <CompleteStreakProgress className={className} objective={objective} />
  ) : (
    <IncompleteStreakProgress className={className} objective={objective} />
  );

export default StreakProgress;
